import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { autocadastroFormColumns } from './autocadastro-form-resource';
import { AutocadastroService } from 'src/app/shared/api/autocadastro.service';
import { FormularioDinamicoComponent } from 'src/app/shared/components/formulario-dinamico/formulario-dinamico.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/shared/services/notificationService';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';

@Component({
    selector: 'app-autocadastro-form',
    templateUrl: './autocadastro-form.component.html',
    styleUrls: ['./autocadastro-form.component.scss']
})
export class AutocadastroFormComponent implements OnInit {
    @ViewChild('formularioAutocadastro') formularioAutocadastro!: FormularioDinamicoComponent;

    idAutocadastro!: string;

    autocadastroFormColumns = autocadastroFormColumns;
    loading = false;
    credenciaisEnviadas = false;

    constructor(
        private autocadastroService: AutocadastroService,
        private route: ActivatedRoute,
        private router: Router,
        private notify: NotificationService
    ) {}

    ngOnInit(): void {
        this.idAutocadastro = this.route.snapshot.paramMap.get('id')!;
    }

    onClickBotao() {
        this.salvarAutocadastro();
    }

    private salvarAutocadastro() {
        if (!this.formularioAutocadastro.isValid()) return;

        const formulario = this.formularioAutocadastro.getDadosFormularioSalvar();
        this.loading = true;
        this.autocadastroService.receberLicenca(this.idAutocadastro, formulario).subscribe({
            next: (response) => {
                this.loading = false;
                this.credenciaisEnviadas = true;
            },
            error: (err) => {
                this.loading = false;

                if (err.status === 404) {
                    this.router.navigate([
                        ConstantsRotasDoSistema.DEFAULT_PATH + ConstantsRotasDoSistema.AUTOCADASTRO + '/esgotado'
                    ]);
                    return;
                }

                this.formularioAutocadastro.tratarErroRequisicao(err);
                this.notify.error('Autocadastro indisponível, contate o suporte');
            }
        });
    }
}
